const QueryOverview = () => {
    return (
        <header className="km-pageHeader">
            <div className="km-container km-enter">
                <p className="km-eyebrow">Contact us</p>
                <h1>Send us a query</h1>
                <p className="km-lead">
                    Have a question about SAHPRA licensing, our services or our webinars? Send us a message
                    and a consultant will get back to you.
                </p>
            </div>
        </header>
    );
};

export default QueryOverview;
